import type { AsaasOrderInfo, AsaasPaymentSource } from './types';

type AsaasSourceOrder = Pick<AsaasOrderInfo, 'packageId' | 'orderAction' | 'trafficPackageType'>;

export function deriveAsaasPaymentSource(order: AsaasSourceOrder): AsaasPaymentSource {
  if (order.packageId === 11) return 'lightweight';
  if (order.packageId === 8 || order.trafficPackageType) return 'traffic';
  if (order.orderAction === 'UPGRADE' || order.orderAction === 'RENEW') return 'upgrade-renew';
  return 'purchase';
}
